import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { RegistrationService } from '../../services/registration.service';

@Component({
    selector: 'unsubscribe',
    template: require('./unsubscribe.component.html')
})
export class UnsubscribeComponent implements OnInit {
    routeParamsSub: Subscription;

    unsubscribeComplete: boolean;
    unsubscribeError: boolean;

    id: number;

    constructor(private readonly route: ActivatedRoute, private readonly registrationService: RegistrationService) {}

    ngOnInit() {
        if (this.routeParamsSub) {
            this.routeParamsSub.unsubscribe();
        }

        this.routeParamsSub = this.route.params.subscribe(params => {
            this.id = params['id'];

            this.unsubscribe();
        });
    }

    unsubscribe() {
        this.registrationService.unsubscribe(this.id).subscribe(() => {
            this.unsubscribeComplete = true;
        }, () => {
            this.unsubscribeError = true;
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/registration/unsubscribe.component.ts